import { parseISO } from "date-fns";
import axios from "@/common/services/axios";
import {
  Competition,
  CompetitionRequest,
  CompetitionResponse,
  CompetitionStatus,
} from "@/common/models/competition";

const processCompetition = (raw: CompetitionResponse): Competition => ({
  id: raw.id,
  name: raw.name,
  caption: raw.caption,
  description: raw.description,
  avatar: raw.avatar,
  kind: raw.kind,
  sport: null,
  matches: [],
  status: raw.status as unknown as CompetitionStatus,
  teams: raw.teams,
  startTime: parseISO(raw.start_time),
  endTime: parseISO(raw.end_time),
  created: parseISO(raw.created_at),
  updated: parseISO(raw.updated_at),
  createdBy: raw.created_by,
  updatedBy: raw.updated_by,
});

export const fetchCompetitions = async (): Promise<Competition[]> => {
  const response = await axios.get<CompetitionResponse[]>("/competitions", {});
  return Array.isArray(response.data) ? response.data.map((c) => processCompetition(c)) : [];
};

export const fetchCompetition = async (id: string) => {
  const response = await axios.get<CompetitionResponse>(`/competitions/${id}`);
  return processCompetition(response.data);
};

export const createCompetition = async (request: CompetitionRequest): Promise<Competition> => {
  const response = await axios.post<CompetitionResponse>("/competitions", request);
  return processCompetition(response.data);
};

export const deleteCompetition = async (id: string): Promise<void> => {
  await axios.delete(`/competitions/${id}`);
};

export const deleteCompetitions = async (): Promise<void> => {
  await axios.delete("/competitions");
};
